import React from "react";

const ContactlessOptionsBus = (props) => {
  const options = [
    {
      text: 'Help, I’m having trouble with my terminal.',
      handler: props.actionProvider.ContactlessBus1,
      id: 1
    },
    {
      text: 'How do INTERAC Debit contactless payments work?',
      handler: props.actionProvider.ContactlessBus2,
      id: 2
    },
    {
      text: 'I already have INTERAC Debit. Do I need a new terminal if I want to start offering contactless payments?',
      handler: props.actionProvider.ContactlessBus3,
      id: 3
    },
    {
      text: 'Are the fees for contactless the same as for Chip and PIN payments?',
      handler: props.actionProvider.ContactlessBus4,
      id: 4
    },
    {
      text: 'What is the payment limit for INTERAC Debit contactless payments?',
      handler: props.actionProvider.ContactlessBus5,
      id: 5
    },
    {
      text: 'What are my obligations in regards to INTERAC Debit contactless payments when it comes to fraud?',
      handler: props.actionProvider.ContactlessBus6,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default ContactlessOptionsBus;